<template>
  <div class="app-download" :style="info.css" @click.prevent="click" data-info="info" v-show="gact.is_h5">
    {{ info.appDownload.text || "下载芒果TV客户端"}}
  </div>
</template>


<script>

  import click_handler from '../../tools/mgtv/click'
  import download_app from '../../tools/mgtv/downapp'
  import handler_action from '../../tools/mgtv/action'

  export default {
    name: 'AppDownload',
    props: ['info'],
    data () {
      return {
        gact: window.gact
      }
    },
    methods: {
      click(){
        click_handler(this.info.name, () => {
          download_app();
        }, {
          need_login: this.info.action_info.need_login,
          need_act: this.info.action_info.need_act,
          need_new_user:this.info.action_info.need_new_user,
          need_vip_level: this.info.action_info.need_vip_level,
        })
      },

    },
    computed: {
      is_edit(){
        return gact.edit
      },


    },
    mounted(){

    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
  .app-download
    font-size .22rem
    color red
    text-align center
</style>



// WEBPACK FOOTER //
// src/components/ConfigUI/AppDownload.vue